export enum CategoryType {
  TO_RESPOND = 1,
  FYI = 2,
  COMMENT = 3,
  NOTIFICATION = 4,
  MEETING_UPDATE = 5,
  WAIT_TO_REPLY = 6,
  ACTIONED = 7,
  MARKETING = 8,
}
